"use strict";
define(
'stores/badges',[
    "stores/store",
    "actions/badges",
    "constants/actiontypes"
],
function (StoreBase, Action, Constants)
{
    Store.prototype = new StoreBase();
    Store.constructor = Store;

    function Store (params)
    {
        // Call parent constructor
        StoreBase.call(this, params);

        // Setup the instance
        this.badges = {};

        this.registerDispatchListener(function (action) {
            switch(action.actionType) {
                case Constants.ADD_BADGE:

                    if (Array.isArray(action.data)) {
                        _.each(action.data, this.addBadge.bind(this));
                    } else {
                        this.addBadge(action.data);
                    }
                    
                    this.event.emit("change");
                    break;
            }
        }.bind(this));

        this.action = new Action();
    }

    Store.prototype.addBadge = function(data)
    {
        var guid = data.guid.toLowerCase();

        // Delete existing
        if (this.badges[guid]) {
            delete this.badges[guid];
        }
        
        data.created_at = new Date(data.created_at);
        data.updated_at = new Date(data.updated_at);
        this.badges[guid] = data;
    };

    Store.prototype.getAll = function()
    {
        if (Object.values) {
            return Object.values(this.badges);
        } else {
            var self = this;
            return Object.keys(this.badges).map(function(key) {
                return self.badges[key];
            });
        }
    };

    Store.prototype.getMostRecentAnimation = function() {
        var mostRecentAnimation = null;
        for (var badgeID of Object.keys(this.badges)) {
            var badge = this.badges[badgeID];
            if(badge.preview_url !== null && badge.earned_at !== null) {
                if(mostRecentAnimation === null) {
                    mostRecentAnimation = badge;
                } else if(mostRecentAnimation.earned_at < badge.earned_at) {
                    mostRecentAnimation = badge;
                }
            }
        }

        return mostRecentAnimation;
    }

    Store.prototype.getMostRecentBadge = function() {
        var mostRecentBadge = null;
        for (var badgeID of Object.keys(this.badges)) {
            var badge = this.badges[badgeID];
            if(badge.preview_url === null && badge.earned_at !== null) {
                if(!mostRecentBadge) {
                    mostRecentBadge = badge;
                } else if(mostRecentBadge.earned_at < badge.earned_at) {
                    mostRecentBadge = badge;
                }
            }
        }

        return mostRecentBadge;
    }

    Store.prototype.getNextUnearned = function(metric) {
        var nextUnearned = null;
        for (var badgeID of Object.keys(this.badges)) {
            var badge = this.badges[badgeID];
            if(badge.metric === metric) {
                if(badge.earned_at !== null) {
                    continue;
                } else if(nextUnearned === null) {
                    nextUnearned = badge;
                } else if(nextUnearned.threshold > badge.threshold) {
                    nextUnearned = badge;
                }
            }
        }

        return nextUnearned;
    }

    Store.prototype.getAnimatedBadgeMetrics = function() {
        var total = 0;
        var earned = 0;

        for (var badgeID of Object.keys(this.badges)) {
            var badge = this.badges[badgeID];
            if(badge.preview_url !== null) {
                total++;
                if(badge.earned_at !== null) {
                    earned++;
                }
            }
        }

        return {
            total, earned
        }
    }

    Store.prototype.findGUID = function (guid)
    {
        return this.badges[guid] || undefined;
    };

    return Store;
});

